import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import NotificationGroup from "./notification-group";
import { NotificationGroup as NotificationGroupType } from "./types";

const FeedContainer = css({
    padding: token("space.200")
});

interface GroupedNotifications {
    today: NotificationGroupType[];
    yesterday: NotificationGroupType[];
    thisWeek: NotificationGroupType[];
    thisMonth: NotificationGroupType[];
    older: NotificationGroupType[];
}

interface NotificationFeedProps {
    groupedNotifications: GroupedNotifications;
    onExpand: (groupId: string, continuationToken?: string) => void;
    notificationLogUrl: string;
    loadingGroupId?: string | null;
}

const NotificationFeed = ({
    groupedNotifications,
    onExpand,
    loadingGroupId
}: NotificationFeedProps) => {
    const { today, yesterday, thisWeek, thisMonth, older } =
        groupedNotifications;

    return (
        <div css={FeedContainer}>
            {today.length > 0 && (
                <NotificationGroup
                    title="Today"
                    notificationGroups={today}
                    onExpand={onExpand}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {yesterday.length > 0 && (
                <NotificationGroup
                    title="Yesterday"
                    notificationGroups={yesterday}
                    onExpand={onExpand}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {thisWeek.length > 0 && (
                <NotificationGroup
                    title="This Week"
                    notificationGroups={thisWeek}
                    onExpand={onExpand}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {thisMonth.length > 0 && (
                <NotificationGroup
                    title="This Month"
                    notificationGroups={thisMonth}
                    onExpand={onExpand}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {older.length > 0 && (
                <NotificationGroup
                    title="Older"
                    notificationGroups={older}
                    onExpand={onExpand}
                    loadingGroupId={loadingGroupId}
                />
            )}
        </div>
    );
};

export default NotificationFeed;
